import React from "react";
import { Button, Modal } from "react-bootstrap";

import type { LeaveStatus } from "../../../../../../../core/data/redux/admin-leaves/types";

interface ConfirmActionModalProps {
  show: boolean;
  status: LeaveStatus | null;
  submitting?: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  show,
  status,
  submitting = false,
  onHide,
  onConfirm,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Action</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to {status} this leave request?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={submitting}>
          {submitting ? "Working..." : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;
